// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3-m6q","noInteraction":"EventWrapper_noInteraction__2kox2","pointerPassthrough":"EventWrapper_pointerPassthrough__20_JI"};